// @flow
import "./style/michaelkors.css";
import React from "react";
import withClientPage from "../../hoc/withClientPage";
import withTemplate from "../../hoc/templates/withTemplate";
import withBasic from "../../hoc/templates/withBasic";
import { useTranslation } from 'react-i18next';

// get the URL so we can do some custom overrides
const url = window.location.href;

/**
 * Render custom component that allows for translated text to include a single hyperlink
 * @param {string} privacyLink - first hyperlink URL
 * @returns {element} translated text including hyperlink
 */
const LinkText = ({ privacyLink, termsLink }) => {
  const { t } = useTranslation();

  // create the hyperlink translation to embed in the main translation text
  const link1 = <a href={privacyLink}>{t('michaelkors.link1.text')}</a>

  // add link component to the full translation message using the component argument for the useTranslation hook
  const translatedText = t('michaelkors.footer.link.text', {link1});

  const renderTranslatedText = () => {
    //split translatedText into an array of parts using regex separated by brackets {}
    const parts = translatedText.split(/({[^}]+})/g);

    // iterate over each part using the map function
    return parts.map((part, index) => {
      // find the dynamic link placeholder if it's between brackets
      if (part.startsWith('{') && part.endsWith('}')) {
        return <React.Fragment key={index}>
          {link1}
        </React.Fragment>;
      }
      return <React.Fragment key={index}>{part}</React.Fragment>;
    });
  };

  return (
    <p className='footer'>
      {renderTranslatedText()}
    </p>
  )
}


const urlConfigurations = [
  { hostIncluded: 'michaelkors?lng=es', privacyLinkURL: 'https://policies.google.com/privacy?hl=es' },
  { hostIncluded: 'michaelkors?lng=it', privacyLinkURL: 'https://policies.google.com/privacy?hl=it' },
  { hostIncluded: 'michaelkors?lng=de', privacyLinkURL: 'https://policies.google.com/privacy?hl=de' },
  { hostIncluded: 'michaelkors?lng=fr', privacyLinkURL: 'https://policies.google.com/privacy?hl=fr' },
  { hostIncluded: 'michaelkors?lng=pt', privacyLinkURL: 'https://policies.google.com/privacy?hl=pt' },
  { hostIncluded: 'michaelkors?lng=nl', privacyLinkURL: 'https://policies.google.com/privacy?hl=nl' },
  { hostIncluded: 'michaelkors?lng=ro', privacyLinkURL: 'https://policies.google.com/privacy?hl=ro' },
  { hostIncluded: 'michaelkors?lng=hu', privacyLinkURL: 'https://policies.google.com/privacy?hl=hu' },
  { hostIncluded: 'michaelkors?lng=pl', privacyLinkURL: 'https://policies.google.com/privacy?hl=pl' }
];

const {
  privacyLinkURL = 'https://policies.google.com/privacy',
} = urlConfigurations.find(({ hostIncluded }) => url.includes(hostIncluded)) || {};

const footer = () => (
  <LinkText privacyLink={privacyLinkURL}/>
);

const PassedProps = {
  clientBodyClassNames: "container-fluid michaelkors-main",
  clientContentClassNames: "",
  header: "none",
  headingText: "michaelkors.headingText",
  headingClassNames: "header-text",
  labelAnimation: false,
  inputClassNames: "input-box",
  cardErrorMsg: 'michaelkors.card.error',
  cardInputLabel: "michaelkors.card.label",
  cardInputPlaceholder: "michaelkors.card.placeholder",
  pinErrorMsg: 'michaelkors.pin.error',
  pinInputLabel: "michaelkors.pin.label",
  pinInputPlaceholder: "michaelkors.pin.placeholder",
  buttonClassNames: "btn mb-4 check-balance-button",
  resultsHeadingText: "michaelkors.result",
  showFooter: true,
  footerComponent: footer(),
  showCardEOV: false,
  justifyContent: "start",
  buttonText: "michaelkors.button.text"
};

const clientPageProps = {
  title: "michaelkors.page.title",
  errorMsg: 'michaelkors.error',
  callTranslations: PassedProps.showEnhancedResults
};

const MKUSG = () => null;

export default withClientPage(withTemplate(withBasic(MKUSG), PassedProps), clientPageProps);
